import process from "process";

globalThis.process = process;